import React from "react"
import { Link } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Hero from "../components/hero"

import styles from "../components/section.module.scss"

const NotFoundPage = () => (
  <Layout>
    <SEO title="404 Page Not Found" />
    <Hero title="Sorry, we couldn't find the page you were looking for" />
    <div className={styles.sectionContent}>
      <h2 style={{ paddingBottom: `32px` }}>
        Get back to the safety of <Link to="/">our homepage</Link> or{" "}
        <Link to="/contact-us">get in touch</Link>.
      </h2>
      <img
        src="https://cdn.sanity.io/images/r0z0uhhm/leo-production/c09b3dde1234aa3a6315819102f9355986efc20c-384x216.gif"
        alt="Computer search yealds zero results"
      />
    </div>
  </Layout>
)

export default NotFoundPage
